import { h, clear } from './dom.js';
import { createPattern } from '../core/pattern.js';

export function mountPatternBank(ctx, slot) {
    clear(slot);

    const tabs = h('div.pattern-tabs');
    const header = h('div.lane-header', {}, [
        h('h2', {}, 'Patterns'),
        h('div.lane-controls', {}, [
            h('button.btn', { onClick: addPattern }, '+ New'),
            h('button.btn', {
                onClick: () => ctx.patterns.duplicate(ctx.patterns.getActiveId()),
            }, 'Duplicate'),
            h('button.btn.btn-danger', {
                onClick: () => {
                    const list = ctx.patterns.list();
                    if (list.length <= 1) { alert('Need at least one pattern.'); return; }
                    const active = ctx.patterns.getActive();
                    if (!confirm(`Delete "${active.name}"?`)) return;
                    ctx.patterns.remove(active.id);
                },
            }, 'Delete'),
        ]),
    ]);
    slot.appendChild(header);
    slot.appendChild(tabs);

    function addPattern() {
        const p = createPattern({ name: `Pattern ${ctx.patterns.list().length + 1}` });
        ctx.patterns.add(p);
        ctx.patterns.setActive(p.id);
    }

    function isEmpty(p) {
        for (const t of Object.values(p.tracks || {})) {
            for (const v of (t.steps || [])) if (v) return false;
        }
        return true;
    }

    function render() {
        clear(tabs);
        const activeId = ctx.patterns.getActiveId();
        for (const p of ctx.patterns.list()) {
            const empty = isEmpty(p);
            const tab = h('button.pattern-tab' + (p.id === activeId ? '.active' : '') + (empty ? '.empty' : ''), {
                onClick: () => ctx.patterns.setActive(p.id),
                ondblclick: () => {
                    const name = prompt('Rename pattern:', p.name);
                    if (name) ctx.patterns.rename(p.id, name);
                },
                title: empty
                    ? `${p.name} is empty — switch to it and click cells in the Channel Rack to add notes`
                    : 'Click to switch · double-click to rename',
            }, p.name);
            tabs.appendChild(tab);
        }
    }

    render();
    ctx.bus.on('pattern:listChanged', render);
    ctx.bus.on('pattern:activeChanged', render);
    // Cell toggles fire history:checkpoint, which is our cue to refresh the
    // empty/full styling on the active pattern's tab.
    ctx.bus.on('history:checkpoint', render);
    ctx.bus.on('pattern:cleared', render);
    ctx.bus.on('project:loaded', render);
}
